import * as React from "react";
import { useNavigate } from "react-router-dom";
import { createCatalog } from "src/business/catalog/apiCatalog";
import { mdmBreadcrumbs } from "src/common/mdmBreadcrumbs";
import { msgQueueStore } from "src/components/MsgQueue";
import { PageLayout } from "src/components/PageLayout";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import {
  CatalogCardStore,
  ManagementCatalogCard,
} from "./ManagementCatalogCard";
import { edit2catalog } from "./ManagementCatalogCard/CatalogCardValues";

const newCatalog = "Новый каталог";

const crumbs = mdmBreadcrumbs([
  { type: "ObjAndSpecs", disabled: true },
  { type: "AdminCatalogs" },
  { type: "Name", name: newCatalog },
]);

export const ManagementCatalogNew: React.FC = () => {
  const navigate = useNavigate();
  return (
    <PageLayout title={crumbs}>
      <ManagementCatalogCard
        title={newCatalog}
        okText="Создать"
        cardStore={cardStore}
        submit={(values) => {
          const data = edit2catalog(values);
          return createCatalog(data);
        }}
        onSuccess={({ id }) => {
          msgQueueStore.add({
            type: "success",
            message: "Выполнено создание каталога",
          });
          navigate(makeUrl(PageUrl.managementCatalogEdit, { id }), {
            replace: true,
          });
        }}
      />
    </PageLayout>
  );
};

const cardStore = new CatalogCardStore();
